/**
 * Centralized application configuration
 * All environment-derived constants should be imported from here.
 */

export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1'

export const APP_NAME = import.meta.env.VITE_APP_NAME || 'X-Manager'

export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0'
